import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WeatherService {
    private readonly WEATHER_API_BASE_URL = 'https://api.weatherapi.com/v1';

    private httpClient = inject(HttpClient);

    getWeatherData(city: string, widgetConfig: {
        displayMode: 'current' | 'forecast' | 'both';
        forecastType?: 'hourly' | 'daily';
        daysCount?: number;
    }): Observable<any> {
        const { displayMode, forecastType, daysCount } = widgetConfig;

        if (displayMode === 'current') {
            const url = `${this.WEATHER_API_BASE_URL}/current.json?key=${environment.WEATHER_API_KEY}&q=${encodeURIComponent(city)}`;
            return this.httpClient.get<any>(url);
        }

        let days = 3;
        if (displayMode === 'forecast' && forecastType === 'hourly') {
            days = 2;
        } else if (displayMode === 'forecast' && forecastType === 'daily') {
            days = daysCount || 10;
        } else if (displayMode === 'both') {
            days = forecastType === 'daily' ? (daysCount || 7) : 3;
        }

        const params = new URLSearchParams({
            key: environment.WEATHER_API_KEY,
            q: encodeURIComponent(city),
            days: days.toString(),
            aqi: 'no',
            alerts: 'no'
        });

        const url = `${this.WEATHER_API_BASE_URL}/forecast.json?${params.toString()}`;

        return this.httpClient.get<any>(url);
    }
}
